import { render, staticRenderFns } from "./InsertModal.vue?vue&type=template&id=6f4e07fc&scoped=true"
import script from "./InsertModal.vue?vue&type=script&lang=js"
export * from "./InsertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e07fc",
  null
  
)

export default component.exports